import React from 'react';
import PropTypes from 'prop-types';

import {
    ESRI_SATELLITE_CREDIT_LINK_TEXT,
    ESRI_SATELLITE_CREDIT_PREFIX,
    ESRI_SATELLITE_CREDIT_URL,
} from '../../helpers/esriSatellite';
import {
    ESRI_PARCELS_CREDIT_LINK_TEXT,
    ESRI_PARCELS_CREDIT_PREFIX,
    ESRI_PARCELS_CREDIT_URL,
} from '../../helpers/esriParcels';

const credit = (prefix, url, text) => (
    <span key={url}>
        {prefix}
        <a href={url} target="_blank" rel="noopener noreferrer">
            {text}
        </a>
    </span>
);

// One line in the bottom-left corner (.map__esri-credit) for every third-party
// layer drawn, since the map runs without mapbox's attribution control.
const MapCredits = ({ satellite, parcels }) => {
    const credits = [
        satellite &&
            credit(ESRI_SATELLITE_CREDIT_PREFIX, ESRI_SATELLITE_CREDIT_URL, ESRI_SATELLITE_CREDIT_LINK_TEXT),
        parcels && credit(ESRI_PARCELS_CREDIT_PREFIX, ESRI_PARCELS_CREDIT_URL, ESRI_PARCELS_CREDIT_LINK_TEXT),
    ].filter(Boolean);
    if (!credits.length) return null;

    return (
        <div className="map__esri-credit">
            {credits.reduce((line, item, i) => (i ? [...line, ' · ', item] : [item]), [])}
        </div>
    );
};

MapCredits.propTypes = {
    satellite: PropTypes.bool,
    parcels: PropTypes.bool,
};

MapCredits.defaultProps = {
    satellite: false,
    parcels: false,
};

export default MapCredits;
